exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td.location {\r\n    color: #018E42;\r\n    transition: linear 0.1s;\r\n}\r\n\r\n    td.location:hover {\r\n        color: #FC6119;\r\n        cursor: pointer;\r\n        transition: linear 0.1s;\r\n    }\r\n\r\ntr.active-row {\r\n    background-color: #F1C40F !important;\r\n    transition: linear 0.1s;\r\n}\r\n\r\ntr.active-row td {\r\n    font-weight: 600;\r\n    font-size: 15px;\r\n    transition: linear 0.1s;\r\n}\r\n\r\n.profile .table-striped tbody > tr.active-row > td,\r\n.profile .table-striped tbody > tr.active-row > th {\r\n    background-color: #F1C40F !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/person/details/person-details.component.css
// module id = 991
// module chunks = 1